import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

// Vue form generator imports
import VueFormGenerator from "vue-form-generator";
import "vue-form-generator/dist/vfg.css";

// Axios for ajax requests in vuew
import axios from "axios";
import VueAxios from "vue-axios";

// working with data in a browser
import VueLocalStorage from "vue-localstorage";

// Bootsrap and vue integration
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

// Toast type notification
import VueToast from "vue-toast-notification";
import "vue-toast-notification/dist/theme-default.css";

// Custom libraries
import { isValidPESEL } from "./validators/pesel.js";
import { isValidZipCode } from "./validators/zipCode.js";
import { getObjectValue } from "./utils/utils.js";
import { CognitoAuthPlugin } from "./auth/plugin.js";
import { BackendPlugin } from "@/backend/plugin";
import { CourtsPlugin } from "@/courts/plugin";
import fieldAutocomplete from "./custom_fields/fieldAutocomplete";
import Multiselect from "vue-multiselect";

// Add axios to vue (for making api calls)
Vue.use(VueAxios, axios);

// Use local storage with vue
Vue.use(VueLocalStorage);

// Use toast module (for alerting)
Vue.use(VueToast);

// Install BootstrapVue
Vue.use(BootstrapVue);
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin);

// Install vue-multiselect
Vue.component("multiselect", Multiselect);
Vue.component("fieldAutocomplete", fieldAutocomplete);
// Use Cognito auth plugin
Vue.use(CognitoAuthPlugin, {
  config: {
    user_pool_id: process.env.VUE_APP_COGNITO_USER_POOL_ID,
    client_id: process.env.VUE_APP_COGNITO_CLIENT_ID
  }
});

// Use Backend Plugin
Vue.use(BackendPlugin, {
  config: {
    api_url: process.env.VUE_APP_BACKEND_API_URL,
    stage: process.env.VUE_APP_BACKEND_API_STAGE
  }
});

// Use Courts Plugin
Vue.use(CourtsPlugin, {
  config: {
    api_url: process.env.VUE_APP_COURTS_API_URL,
    stage: process.env.VUE_APP_COURTS_API_STAGE
  }
});

// Add Vue form generator with custom validators
Vue.use(VueFormGenerator, {
  validators: {
    peselValidator: value => {
      if (isValidPESEL(value)) {
        return [];
      } else {
        return ["To nie jest poprawny numer pesel."];
      }
    },
    zipCodeValidator: (value, field, model) => {
      // Validate if zip code is correct based on previous country selection
      // country need to be present in a model
      if (isValidZipCode(value, model.address.country)) {
        return [];
      } else {
        return ["Niepoprawny kod pocztowy."];
      }
    },
    requiredIfValidator: (value, field, model) => {
      var requiredIfFieldValue = getObjectValue(model, field.requiredIf.model);
      if (requiredIfFieldValue == field.requiredIf.value) {
        // now field is truly required
        if (value) {
          return [];
        } else {
          return ["To pole jest wymagane"];
        }
      }
      return [];
    }
  }
});

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  beforeCreate() {
    this.$store.commit("user_init");
  },
  render: h => h(App)
}).$mount("#app");
